export const COMPANY_NAME = "KR GRAYLEE INVESTMENTS LLC";
export const COMPANY_SHORT = "KR Graylee Investments";
export const COMPANY_INITIALS = "KGI";
export const COMPANY_ADDRESS_FULL = "5753 E Santa Ana Canyon Rd, Anaheim, CA 92807-3230";
export const COMPANY_LOCATION = "Anaheim, CA";
export const COMPANY_REGION = "Anaheim, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=5753%20E%20Santa%20Ana%20Canyon%20Rd%2C%20Anaheim%2C%20CA%2092807-3230";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "LLC" },
  { "label": "Location", "value": "Anaheim, CA" },
  { "label": "Profile", "value": "Public directory" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "KR GRAYLEE INVESTMENTS LLC" },
  { "label": "Location", "value": "Anaheim, CA" },
  { "label": "Address", "value": "5753 E Santa Ana Canyon Rd, Anaheim, CA 92807-3230" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Organization", "body": "A concise, public directory profile for KR Graylee Investments." },
  { "icon": "✦", "title": "Local presence", "body": "Listed at a public address in Anaheim, California." },
  { "icon": "✿", "title": "Visit details", "body": "Use the map link to view the listed public address." },
  { "icon": "❍", "title": "Public information", "body": "This profile shares only high-level, directory-safe details." },
];
